import { Type } from '@sinclair/typebox';
import { NullishType } from './standard-schema.js';
const CommonCalculationBudgetSchema = Type.Object({
    accountNumber: Type.Number(), // Kostnadstyp
    numberOfItems: NullishType(Type.Number()), // Mängd
    unit: NullishType(Type.String()), //Enhet
    comment: NullishType(Type.String()), // Kommentar
    pricePerUnit: NullishType(Type.Number()), // Kostnad/Enhet
    netCost: NullishType(Type.Number()), // Nettokostnad
    markupFactor: NullishType(Type.Number()), //Påslag
    grossCost: NullishType(Type.Number()), // Bruttokostnad
    budget: NullishType(Type.Number()), // Budget
    rowIndex: Type.Number(), // Radnummer
});
export const ListCalculationBudgetParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const UpdateCalculationBudgetParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const ListCalculationBudgetSchema = Type.Composite([
    Type.Object({
        id: Type.String(),
    }),
    CommonCalculationBudgetSchema,
]);
export const ListCalculationBudgetResponseSchema = Type.Array(ListCalculationBudgetSchema);
export const UpCreateCalculationBudgetSchema = Type.Composite([
    Type.Object({
        id: NullishType(Type.String()),
    }),
    Type.Omit(CommonCalculationBudgetSchema, ['comment']),
]);
export const UpCreateListCalculationBudgetSchema = Type.Array(UpCreateCalculationBudgetSchema);
export const UpdateCalculationBudgetCommentParamsSchema = Type.Object({
    projectId: Type.String(),
});
export const UpdateCalculationBudgetCommentSchema = Type.Object({
    comments: Type.Array(Type.Object({
        id: Type.String(),
        comment: NullishType(Type.String()),
    })),
});
export const UpdateCalculationBudgetCommentResponseSchema = ListCalculationBudgetResponseSchema;
